import axios from 'axios'

import {
	ElMessageBox
} from 'element-plus'

import $ from 'jquery';

let baseURL = process.env.VUE_APP_API_BASE_URL;

export  function getBaseUrl() {
    if (process.env.NODE_ENV === 'development') {
        return;
    }
    $.ajax({
        type : "get",
        async: false, // fasle表示同步请求，true表示异步请求
        cache: false,
        url : "./config.json",
        data : {},
        success : function(result) {
            if (result && result.url) {
                baseURL = result.url;
            }
        },
        error : function(e){
            console.log(e);
        }
    });
};

//动态获取ip
getBaseUrl();


export function getUrl() {
    return baseURL;
}


// 设置 Axios 的默认 baseURL
axios.defaults.baseURL = baseURL;

// 创建通用 axios 配置
let instance = axios.create({
	baseURL: baseURL,
	responseType: "json",
	headers: {
		'Content-Type': 'application/json'
	},
	timeout: 30000
})


// http 拦截 发出之前
instance.interceptors.request.use(
	config => {
		let token = localStorage.getItem('token')
		if (token) {
			config.headers.authorization = token
		}
		if(config.url.includes('/upload')){
			config.headers['Content-Type'] = 'multipart/form-data'
		}
		return config
	},
	err => {
		return Promise.reject(err)
	}
)

// http 拦截  发出之后
instance.interceptors.response.use(
	response => {
		return response
	},
	err => {
		if (err.response) {
			let status = err.response.status
			let data = err.response.data || {}
			let message = data.message || (data.msg && data.msg.msg) || data.msg || err.message || 'Server error'
			let errdata = status == 401 ? message : '服务器发生错误'
			switch (status) {
				case 401:
					ElMessageBox.alert(errdata, '提示', {
						confirmButtonText: '确认',
						type: 'error'
					}).then(res => {
						// 跳转登录
						window.location.href = '/'
					}).catch(err => {
						// 跳转登录
						window.location.href = '/'
					})
					break;
			}
		}

		if (!err.response) {
			return Promise.reject(err)
		}

		return Promise.reject(err.response.data) // 返回接口错误信息
	}
)

export default instance
